import {AddUserRoute} from "./routes/AddUser.js";
import {UserRoute} from "./routes/User.js";
import {UsersRoute} from "./routes/Users.js";
const routes = [UsersRoute, AddUserRoute, UserRoute];
export default routes;
